export default {
  showCompanySearch: false,
  showLocation: false,
  existActiveCode: false,
  activeCode: '',
  alreadyActivated: false,
  noReportCode: true,
  originData: {},
  formInfo: {
    dealer: '',
    company: '',
    contactPerson: '',
    telephone: '',
    districtArr: [],
    street: ''
  },
  address: {
    province: '',
    city: '',
    district: ''
  },
  locationStreet: ''
};



// WEBPACK FOOTER //
// ./src/stores/form/_state.js